import React, { FunctionComponent, useEffect, useState } from 'react';
import AppRoot, { AppRootProps } from './AppRoot';
import AppContainerSpinner from './AppContainerSpinner';
import { RouteComponentProps } from 'react-router';
import axiosFetch, { setAxiosConfigData } from '../context/axiosFetch';
import { AxiosResponse } from 'axios';
import { useAuthState } from '@trp-ta-nitro/auth-react';
import ErrorPage from './shared/ErrorPage/ErrorPage';
import styles from './shared/ErrorPage/ErrorPage.module.scss';
import mock from '../mock.json';

interface Props extends RouteComponentProps {
  config: ApplicationConfig;
}

const AppNoneLocal: FunctionComponent<Props> = ({ config, ...props }) => {
  const [data, setData] = useState<AssetManagementData | undefined>(undefined);
  const [isDataLoading, setIsDataLoading] = useState<boolean>(true);
  const authState = useAuthState();

  useEffect(() => {
    const headers = {
      'x-trp-requested-with': 'java',
      'Access-Control-Allow-Credentials': true,
      apikey: config.apiKey
    };
    setAxiosConfigData(config.apiKey);
    const url = config.serviceHost + config.dataEndpoint;
    axiosFetch(url, undefined, headers)
      .then((response: AxiosResponse<AssetManagementData>) => {
        setData(response.data);
        setIsDataLoading(false);
      })
      .catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const appProps: AppProps = {
    // @ts-ignore
    applicationConfig: config,
    // @ts-ignore
    data: data,
    logoutCallback: () => {},
    ...authState
  };

  const appRootProps = {
    ...props,
    ...appProps
  } as AppRootProps;

  if (!authState) {
    return (
      <ErrorPage>
        <div className={styles['error-page-message']}>
          There is an authentication error &nbsp;
          <a
            className={styles['error-page-link']}
            href="javascript:window.location.reload(true)">
            try reloading the page.
          </a>
        </div>
      </ErrorPage>
    );
  }

  return isDataLoading ? (
    <AppContainerSpinner />
  ) : (
    <AppRoot {...appRootProps} />
  );
};

const AppLocal: FunctionComponent<Props> = ({ config, ...props }) => {
  useEffect(() => {
    setAxiosConfigData(config.apiKey);
  }, [config.apiKey]);

  const appProps: AppProps = {
    // @ts-ignore
    applicationConfig: config,
    // @ts-ignore
    data: mock,
    logoutCallback: () => {}
  };

  const appRootProps = {
    ...props,
    ...appProps
  } as AppRootProps;

  return <AppRoot {...appRootProps} />;
};
const App: FunctionComponent<Props> =
  process.env.NODE_ENV === 'development' ? AppLocal : AppNoneLocal;

export default App;
